/* eslint-disable @typescript-eslint/no-explicit-any,import/no-restricted-paths */

import { IYmaps } from '../../../../browser/ymaps/types';

import * as styles from './index.css';

const DEFAULT_INSIDE_ICON_IMAGE = `<g mask="url(#map-placemark-c)">
    <path fill="none" d="M13 13h20v20H13z"/>
    <path fill="#00AEEF" d="M18 13h5v5h-5z"/>
    <path fill="#DB0278" d="M18 18h8v6H13zM23 24h7v8H15z"/>
    <path fill="#00AEEF" d="M25.467 17L32 24H18zM15 24h8l-8 8z"/>
    <path fill="#15244D" d="M15 24h15l-8 8z"/>
  </g>`;

const getInsideIconImage = (imageUrl?: string) =>
  imageUrl ? `<image xlink:href="${imageUrl}" x="13" y="13" height="20px" width="20px" />` : DEFAULT_INSIDE_ICON_IMAGE;

export const getIconLayout = (ymaps: IYmaps, color: string, insideImageUrl?: string) => {
  return ymaps.templateLayoutFactory.createClass(
    `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="62" height="69" viewBox="0 0 62 69">
      <defs>
        <path id="map-placemark-a" d="M20.28 45.84C8.86 44.496 0 34.783 0 23 0 10.297 10.297 0 23 0s23 10.297 23 23c0 11.782-8.86 21.495-20.28 22.84L23 54l-2.72-8.16z"/>
        <filter id="map-placemark-b" width="169.6%" height="159.3%" x="-34.8%" y="-14.8%" filterUnits="objectBoundingBox">
          <feOffset dy="8" in="SourceAlpha" result="shadowOffsetOuter1"/>
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="4"/>
          <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
        </filter>
      </defs>
      <g fill="none" fill-rule="evenodd" transform="translate(8)">
        <ellipse cx="23" cy="53.5" fill="#000" fill-opacity=".15" rx="5" ry="1.5"/>
        <mask id="map-placemark-c" fill="#fff">
          <use xlink:href="#map-placemark-a"/>
        </mask>
        <use fill="#000" filter="url(#map-placemark-b)" xlink:href="#map-placemark-a"/>
        <use fill="#FFF" xlink:href="#map-placemark-a"/>
        <path fill="${color}" fill-opacity=".2" d="M23 43c11.046 0 20-8.954 20-20S34.046 3 23 3 3 11.954 3 23s8.954 20 20 20z" mask="url(#map-placemark-c)"/>
        ${getInsideIconImage(insideImageUrl)}
      </g>
    </svg>`,
  );
};

const getBalloonMarkup = (isJkMap: boolean) =>
  `<div class="${styles['container']} ${isJkMap ? styles['jk'] : ''}">
    $[properties.balloonContent]
    <button class="${styles['close']}">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.728 12.728" width="10" height="10">
        <path fill="currentColor" d="M6.364 4.95L1.414 0 0 1.414l4.95 4.95L0 11.314l1.414 1.414 4.95-4.95 4.95 4.95 1.414-1.414-4.95-4.95 4.95-4.95L11.314 0l-4.95 4.95z"/>
      </svg>
    </button>
  </div>`;

// tslint:disable:object-literal-shorthand no-any max-line-length no-invalid-this
const getBalloonOverrides = (ymaps: any, id: string) => ({
  build() {
    (this as any).constructor.superclass.build.call(this);

    const containerSelector = `#${id} .${styles['container']}`;
    (this as any)._balloon = document.querySelector(containerSelector) as Element;
    if ((this as any)._balloon) {
      (this as any)._balloon.style.bottom = `${(this as any)._balloon.offsetHeight + 65}px`;
    }

    const closeSelector = `#${id} .${styles['close']}`;
    const closeButton = document.querySelector(closeSelector) as Element;
    closeButton.addEventListener('click', event => (this as any).onCloseClick.call(this, event));
  },
  getShape() {
    if (!(this as any)._balloon) {
      return (this as any).constructor.superclass.getShape.call(this);
    }
    const { offsetLeft, offsetTop, offsetWidth, offsetHeight } = (this as any)._balloon;

    return new ymaps.shape.Rectangle(
      new ymaps.geometry.pixel.Rectangle([
        [offsetLeft, offsetTop],
        [offsetLeft + offsetWidth, offsetTop + offsetHeight],
      ]),
    );
  },
  onCloseClick(event: any) {
    event.preventDefault();

    (this as any).events.fire('userclose');
  },
});

export function getBalloonLayout(ymaps: IYmaps, isJkMap: boolean, id: string) {
  return ymaps.templateLayoutFactory.createClass(getBalloonMarkup(isJkMap), getBalloonOverrides(ymaps, id));
}
